import { Component, Inject, Injector, PLATFORM_ID } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { GoogleTagManagerService } from 'projects/qo-commons/src/services/google-tag-manager/google-tag-manager.service';
import { EnvironmentService } from './core/services/environment/environment.service';
import { QOME_PUBLIC_API_CONFIGURATION } from 'projects/qome-public-api/src/configuration';
@Component({
    selector: 'qo-root',
    imports: [
        RouterOutlet
    ],
    templateUrl: './app.component.html'
})
export class AppComponent {
    constructor(injector: Injector,
        environmentService: EnvironmentService,
        router: Router,
        googleTagManagerService: GoogleTagManagerService,
        @Inject(PLATFORM_ID) platformId: Object) {
            
            router.events
            .subscribe((event) => {
                if(event instanceof NavigationEnd) {
                    googleTagManagerService.logPageView(event.url);
                }
            });
            
            if(environmentService.settings && environmentService.settings.PublicApiBaseUrl) {
                // Initialize public API configuration
                const qomePublicApiConfiguration = injector.get(QOME_PUBLIC_API_CONFIGURATION);
                qomePublicApiConfiguration.basePath = environmentService.settings.PublicApiBaseUrl;
            }
            
            if(environmentService.settings && environmentService.settings.GTMSiteId) {
                googleTagManagerService.init(environmentService.settings.GTMSiteId);
                googleTagManagerService.initDefaultConsent();
                googleTagManagerService.initCookieBanner();
            }
        }
    }
    